import { Cell, Grid, useStyles } from 'bold-ui'
import moment from 'moment'
import React, { CSSProperties } from 'react'
import { capitalize } from 'util/strConversor'
import { useListaAtendimentoStyles } from 'view/atendimentos/list/useListaAtendimentoStyles'

import { ListaAtendimentoFilterModel } from './ListaAtendimentoFilter'
import { ListaAtendimentoFilterItem } from './ListaAtendimentoFilterItem'

interface ListaAtendimentoFilterTagsProps {
  filtros: ListaAtendimentoFilterModel
  onChange(values: ListaAtendimentoFilterModel): void
}

export function ListaAtendimentoFilterTags(props: ListaAtendimentoFilterTagsProps) {
  const { classes } = useStyles(createStyles)
  const statusMap = useListaAtendimentoStyles()

  const statusAtendimentoText =
    props.filtros.statusAtendimento?.length > 0 &&
    props.filtros.statusAtendimento.map((item) => statusMap.get(item).descricao).join(', ')

  const statusAtendimento = props.filtros.statusAtendimento?.length > 0 && (
    <ListaAtendimentoFilterItem label='Status do atendimento:' value={statusAtendimentoText} filtros={props.filtros} />
  )

  const periodoText =
    props.filtros?.periodo?.startDate &&
    props.filtros?.periodo?.endDate &&
    `(${moment(props.filtros.periodo.startDate).format('DD/MM/YYYY')} até ${moment(
      props.filtros.periodo.endDate
    ).format('DD/MM/YYYY')})`

  const periodo = !props.filtros.somenteNaoFinalizados &&
    props.filtros.periodo?.startDate &&
    props.filtros.periodo?.endDate && (
      <ListaAtendimentoFilterItem
        label='Período:'
        value={periodoText}
        filtros={props.filtros}
        style={classes.periodoColumn}
      />
    )

  const showSomenteNaoFinalizados = props.filtros.somenteNaoFinalizados && (
    <ListaAtendimentoFilterItem
      value='Somente atendimentos não finalizados'
      filtros={props.filtros}
      style={classes.periodoColumn}
      textStyle={{ fontWeight: 'bold' }}
    />
  )

  const tipoServicoText =
    props.filtros.tiposServico?.length > 0 && props.filtros.tiposServico.map((item) => capitalize(item.nome)).join(', ')

  const tipoServico = props.filtros.tiposServico?.length > 0 && (
    <ListaAtendimentoFilterItem label='Tipo de serviço:' value={tipoServicoText} filtros={props.filtros} />
  )

  const equipeText = props.filtros.equipes?.length > 0 && props.filtros.equipes.map((item) => item.nome).join(', ')

  const equipe = props.filtros.equipes?.length > 0 && (
    <ListaAtendimentoFilterItem label='Equipe:' value={equipeText} filtros={props.filtros} />
  )

  const lotacoesText =
    props.filtros.lotacoes?.length > 0 && props.filtros.lotacoes.map((item) => item.profissional.nome).join(', ')

  const lotacoes = props.filtros.lotacoes?.length > 0 && (
    <ListaAtendimentoFilterItem label='Profissionais:' value={lotacoesText} filtros={props.filtros} />
  )

  return (
    <Grid>
      <Cell size={12} style={{ paddingTop: 0, marginBottom: '0.5rem' }}>
        <Grid alignItems='center' justifyContent='flex-start' gap={0.25} gapVertical={0.25} wrap={false}>
          {statusAtendimento || showSomenteNaoFinalizados || periodo || tipoServico || equipe || lotacoes ? (
            <>
              {statusAtendimento}
              {periodo}
              {showSomenteNaoFinalizados}
              {tipoServico}
              {equipe}
              {lotacoes}
            </>
          ) : (
            'Sem filtros ativos'
          )}
        </Grid>
      </Cell>
    </Grid>
  )
}

const createStyles = () => ({
  periodoColumn: {
    overflow: 'visible',
  } as CSSProperties,
})
